import { Component, OnInit, OnDestroy, ViewChild, HostListener, ViewEncapsulation, AnimationTransitionEvent } from '@angular/core';
import { MenuItems } from '../core/menu/menu-items/menu-items';
import {BreadcrumbService} from 'ng5-breadcrumb';
import { PageTitleService } from '../core/page-title/page-title.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
// import { Subscription } from 'rxjs/Subscription';
import {MediaChange, ObservableMedia} from '@angular/flex-layout';
import PerfectScrollbar from 'perfect-scrollbar';
import { TourService } from 'ngx-tour-ng-bootstrap';
import { SharedDataService } from '../shared-data.service';
import { Http } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar } from '../../../node_modules/@angular/material';
// import {MatBadgeModule} from '@angular/material/badge';
// import { HomeComponent } from '../../app/pages/home/home.component';
// import { LoginoneComponent } from '../session/loginone/loginone.component';
import * as _ from 'lodash';
declare var $: any;
import * as moment from 'moment';
moment().format();

// const screenfull = require('screenfull');

@Component({
    selector: 'chankya-layout',
  	templateUrl:'./main-material.html',
  	styleUrls: ['./main-material.scss'],
    encapsulation: ViewEncapsulation.None
})
export class MainComponent implements OnInit, OnDestroy{
  employeeSelectedBranch = '';
  disableBranchSelect = false;
  
    private _router: Subscription;
    header: string;
    currentLang = 'en';
    favList=[{name:'',route:''}]
    languageList=[
      {name:'Default English (Eng)',CountryICO:'',isSel:true,param:'en'},
      {name:'French (Fr)',CountryICO:'',isSel:false,param:'fr'},
    ]
    url: string;
    showSettings = false;
    themeSkinColor: any = "light";
    dark: boolean;
    boxed: boolean;
    collapseSidebar: boolean;
    compactSidebar: boolean;
    customizerIn: boolean = false;
    chatWindowOpen: boolean = false;
    chatSidebar: boolean = false;
    sidebarClosed: boolean = false;
    root = 'ltr';
    chatpanelOpen: boolean = false;
    searchOn = false;
    logo: any;
    username: string;
    schoolName: string;
    public schoolColor = '#c5c5c5';
    public schoolColor2 = '#6fa6e64d;'
    // public schoolColoer2 = 'rgb(111 166 230 / 50%);'
    profileImage = 'assets/3.png';

    private _mediaSubscription: Subscription;
    sidenavOpen: boolean = true;
    sidenavMode: string = 'side';
    isMobile: boolean = false;
    private _routerEventsSubscription: Subscription;
    public innerWidth: any;
    showLastLoginDiv:boolean = false;

    @ViewChild('sidenav') sidenav;

    _opened: boolean = true;
    _mode: string = "push";
    _closeOnClickOutside: boolean = false;
    _showBackdrop: boolean = false;

    public _toggleOpened(): void {
        this._opened = !this._opened;
     }

    routingFromForm:boolean = false;
    reduceForIframe:boolean = false;
	constructor(
        public http: Http,
        public tourService: TourService,
        public menuItems: MenuItems,
        private breadcrumbService: BreadcrumbService,
        private pageTitleService: PageTitleService,
        public translate: TranslateService,
        private router: Router,
        // private home: HomeComponent,
        private media: ObservableMedia,
        private domSanitizer: DomSanitizer,
        private matSnackbar: MatSnackBar,
        public sharedDataService: SharedDataService,
        // public login: LoginoneComponent
    ) {
        if (sharedDataService.school_id == null) {
            // let token = sessionStorage.getItem('tokenInfo');
            // let tokenFull = localStorage.getItem('tokenInfoFull');
            // if (token !== null) {
            //     sessionStorage.setItem('tokenInfoFull',  tokenFull );
            //     sharedDataService.encoded64BitAuth = localStorage.getItem('auth');
            //     this.sharedDataService.tokenInformation = JSON.parse(token);
            //     this.sharedDataService.schoolInformation = JSON.parse(token);                    
            //     this.logo = 'assets/logo_place.png';
            //     let desiredURL = router.url;
            //     this.router.navigate(["/home"], {queryParams: {recache: true, page: desiredURL}});
            // }
            if (window.location.href.includes('ids-school-form') ) {
                
                document.body.style.setProperty('--schcol', '#6fa6e6');
                this.routingFromForm = true;
            }
            else{
                sharedDataService.celebrate('Unable to Authenticate User, Please Sign In');
                this.router.navigate(['/login']);    
            }
            return;
        }
        if (sessionStorage.getItem('inIframe')) {
            this.reduceForIframe = true;
        }
        if (window.location.href.includes('ids-school-form') ) {
            
            document.body.style.setProperty('--schcol', '#6fa6e6');
            this.routingFromForm = true;
            return;
        }
        this.logo = 'assets/logo_place.png';
        this.sharedDataService.logo = 'assets/logo_place.png';
        this.getProfileInformation();
        this.getUserProfilePicture();
        // this.getdata();
        // menuItems.setVars(this.sharedDataService.tokenInformationServe.Role_Name);
        translate.addLangs(['en', 'fr']);
        translate.setDefaultLang('en');
        const browserLang: string = translate.getBrowserLang();
        translate.use(browserLang.includes('en') || browserLang.includes('fr') ? browserLang : 'en');

        breadcrumbService.addFriendlyNameForRoute('/dashboard', 'Dashboard');
        breadcrumbService.addFriendlyNameForRoute('/dashboard/dashboard-v1', 'Dashboard V1');
        breadcrumbService.addFriendlyNameForRoute('/dashboard/dashboard-v2', 'Dashboard V2');
        breadcrumbService.addFriendlyNameForRoute('/inbox', 'Apps / Inbox');
        breadcrumbService.addFriendlyNameForRoute('/chat', 'Apps / Chat');
        breadcrumbService.addFriendlyNameForRoute('/calendar', 'Apps / Calendar');

        breadcrumbService.addFriendlyNameForRoute('/ui-elements', 'UI-Element');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/buttons', 'Buttons');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/progress', 'Progress');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/tabs', 'Tabs');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/accordions', 'Accordions');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/pagination', 'Pagination');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/tooltip', 'Tooltip');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/cards', 'Cards');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/social-icons', 'Social Icons');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/typography', 'Typography');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/dropdown', 'Dropdown');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/alert', 'Alert');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/carousel', 'Carousel');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/datepicker', 'Datepicker');
        breadcrumbService.addFriendlyNameForRoute('/ui-elements/slider', 'Slider');

        breadcrumbService.addFriendlyNameForRoute('/components', 'Components');
        breadcrumbService.addFriendlyNameForRoute('/components/list', 'List');
        breadcrumbService.addFriendlyNameForRoute('/components/grids', 'Grids');

        breadcrumbService.addFriendlyNameForRoute('/forms', 'Forms');
        breadcrumbService.addFriendlyNameForRoute('/forms/form-elements', 'Form Elements');
        breadcrumbService.addFriendlyNameForRoute('/forms/form-group', 'Form Group');
        breadcrumbService.addFriendlyNameForRoute('/forms/form-wizard', 'Form Wizard');
        breadcrumbService.addFriendlyNameForRoute('/forms/form-validation', 'Form Validation');
        breadcrumbService.addFriendlyNameForRoute('/forms/form-upload', 'Form Upload');
        breadcrumbService.addFriendlyNameForRoute('/forms/form-tree', 'Tree');

        breadcrumbService.addFriendlyNameForRoute('/tables', 'Table');
        breadcrumbService.addFriendlyNameForRoute('/tables/fullscreen', 'Full Screen');
        breadcrumbService.addFriendlyNameForRoute('/tables/selection', 'Selection');
        breadcrumbService.addFriendlyNameForRoute('/tables/pinning', 'Pinning');
        breadcrumbService.addFriendlyNameForRoute('/tables/sorting', 'Sorting');
        breadcrumbService.addFriendlyNameForRoute('/tables/Paging', 'Paging');
        breadcrumbService.addFriendlyNameForRoute('/tables/editing', 'Editing');
        breadcrumbService.addFriendlyNameForRoute('/tables/filter', 'Filter');

        breadcrumbService.addFriendlyNameForRoute('/dragndrop', 'Drag and Drop');
        breadcrumbService.addFriendlyNameForRoute('/dragndrop/dragula', 'Dragula');
        breadcrumbService.addFriendlyNameForRoute('/dragndrop/sortable', 'SortableJS');

        breadcrumbService.addFriendlyNameForRoute('/chart', 'Charts');
        breadcrumbService.addFriendlyNameForRoute('/chart/ng2-charts', 'NG2 Charts');
        breadcrumbService.addFriendlyNameForRoute('/chart/easy-pie-chart', 'Easy Pie');
        breadcrumbService.addFriendlyNameForRoute('/chart/google-chart', 'Google Charts');

        breadcrumbService.addFriendlyNameForRoute('/maps', 'Maps');
        breadcrumbService.addFriendlyNameForRoute('/maps/googlemap', 'Google Map');
        breadcrumbService.addFriendlyNameForRoute('/maps/vectormap', 'Vector Map');
        breadcrumbService.addFriendlyNameForRoute('/maps/leaflet', 'Leaflet Map');

        breadcrumbService.addFriendlyNameForRoute('/user-pages', 'User Pages');
        breadcrumbService.addFriendlyNameForRoute('/user-pages/userlist', 'User List');
        breadcrumbService.addFriendlyNameForRoute('/user-pages/usertable', 'User Table');
        breadcrumbService.addFriendlyNameForRoute('/user-pages/userprofile', 'User Profile');

        breadcrumbService.addFriendlyNameForRoute('/emails', 'Emails');
        breadcrumbService.addFriendlyNameForRoute('/emails/email-listing', 'Email Listing');
        breadcrumbService.addFriendlyNameForRoute('/emails/email-detail', 'Email Detail');
        breadcrumbService.addFriendlyNameForRoute('/emails/email-compose', 'Email Compose');

        breadcrumbService.addFriendlyNameForRoute('/ecommerce', 'Ecommerce');
        breadcrumbService.addFriendlyNameForRoute('/ecommerce/ecommerce-product', 'Ecommerce Product');
        breadcrumbService.addFriendlyNameForRoute('/ecommerce/ecommerce-product-detail', 'Ecommerce Product Detail');

        breadcrumbService.addFriendlyNameForRoute('/pages', 'Pages');
        breadcrumbService.addFriendlyNameForRoute('/pages/timeline', 'Timeline');
        breadcrumbService.addFriendlyNameForRoute('/pages/subscribes', 'Subscribes');
        breadcrumbService.addFriendlyNameForRoute('/pages/undermaintance', 'Under Maintance');
        breadcrumbService.addFriendlyNameForRoute('/pages/testimonials', 'Testimonials');
        breadcrumbService.addFriendlyNameForRoute('/pages/pricing', 'Pricing');
        breadcrumbService.addFriendlyNameForRoute('/pages/blank', 'Blank');
        breadcrumbService.addFriendlyNameForRoute('/session', 'Session');
        breadcrumbService.addFriendlyNameForRoute('/session/login', 'Login');
        breadcrumbService.addFriendlyNameForRoute('/session/register', 'Register');
        breadcrumbService.addFriendlyNameForRoute('/session/forgot-password', 'Forgot');
        breadcrumbService.addFriendlyNameForRoute('/session/lockscreen', 'Lock Screen');
    }


    hideToolbar = false;
    lastLoginInfo = {
        time: null,
        device: null,
        location: null
    }
    canViewLastLoginDetails:boolean = false;
    ngAfterViewInit(){
        // if(this.sharedDataService.school_agreement == null){
        //     this.sharedDataService.getSchoolAgreement();
        // }
        if(this.sharedDataService.school_prepaid_services == null){
            this.sharedDataService.getSchoolPrepaidServices();
        }
        //this.sharedDataService.getEmployeeBranches();
        if (!this.routingFromForm) {
            this.tillRolesCome();   
        }
        //  if (sessionStorage.getItem('inIframe')) {
        //     this.sidebarClosedFunction2();
        //  }
        document.addEventListener('keydown',(e)=>{
          // e.preventDefault()
          if(e.ctrlKey && e.key=='m'){
            this.customizerFunction()
          }
         })
         
        if (window.location.href.includes('hideSidebar=1') || this.routingFromForm) {
            this.hideToolbar = true;
            if (!this.sidebarClosed) {
                this.sidebarClosedFunction2();
            }
        }

        if (!this.routingFromForm) {
            let tokenInfo = sessionStorage.getItem("tokenInfoFull");
            let tokenInfoJson = JSON.parse(tokenInfo);
            this.canViewLastLoginDetails = this.userHasThisPermission('View Last Login Details');
            // let showLocationFirst = true;
            this.lastLoginInfo.time = moment(tokenInfoJson.Last_Login_Datetime).fromNow();
            this.lastLoginInfo.device = tokenInfoJson.Last_Login_Xdevice_Info;
    
            let locationURL;
            let loginLocation = tokenInfoJson.Last_Login_Xlocation == null || tokenInfoJson.Last_Login_Xlocation == '' ? 'Unspecified Location' : tokenInfoJson.Last_Login_Xlocation;
    
            if (!sessionStorage.getItem('shownLastLoginPrompt')) {
                sessionStorage.setItem('shownLastLoginPrompt', 'true');
                setTimeout(() => {
                    this.showLastLoginDiv = true;
                }, 2000);    
            }
    
            if (loginLocation !== 'Unspecified Location') {
                let locationjoined = '';
                if (loginLocation.includes(' ')) {
                    locationjoined = loginLocation.split(' ').join('');
                }
                else{
                    locationjoined = loginLocation
                }
    
                locationURL = 'https://maps.googleapis.com/maps/api/staticmap?center=' + locationjoined + '&zoom=18&size=480x410&markers=color:red%7C' + locationjoined + '&key=AIzaSyC0lSt2Arj-MHo6ATzhaxApNVQL1S0BQUY';
            }
    
            this.lastLoginInfo.device = locationURL ? locationURL : null;
            setTimeout(() => {
                this.showLastLoginDiv = false
            }, 25000);                
        }
    }

    searchName(){
      const url=window.location.href.split("/")[window.location.href.split("/").length-1]
      // const name=  AppRoutes[1].children.find(item=>item.path==url)
    }

    choseLang(lang){
      this.languageList.forEach(item=>{
        if(lang.name==item.name){
          item.isSel=true
          this.translate.use(lang.param);
        }else{
          item.isSel=false
        }
      })
    }

    hideLastLogin(){
        this.showLastLoginDiv = false;
    }
    
    showLastLoginInfo(){
        let tokenInf = sessionStorage.getItem("tokenInfoFull");
        let tokenInfo = JSON.parse(tokenInf);
            let message = 
            `<div class="row">
                <div class="col-12 text-center mb-2">
                    <span><i style="color: ${this.sharedDataService.school_color}" class="fa fa-calendar"></i> ${moment(tokenInfo.Last_Login_Datetime).format('DD. MMMM. YYYY, hh:mm a')}</span>
                </div>
            </div>`;
        
        if (this.userHasThisPermission('View Last Login Details')) {
            message += `<div class="row">
                <div class="col-12 text-center">
                    <span><i style="color: ${this.sharedDataService.school_color}" class="fa fa-laptop"></i> ${tokenInfo.Last_Login_Xdevice_Info}</span>
                </div>
            </div>`  

          let locationURL;
          let loginLocation = tokenInfo.Last_Login_Xlocation == null || tokenInfo.Last_Login_Xlocation == '' ? 'Unspecified Location' : tokenInfo.Last_Login_Xlocation;
          if (loginLocation !== 'Unspecified Location') {
            let locationjoined = '';
            if (loginLocation.includes(' ')) {
              locationjoined = loginLocation.split(' ').join('');
            }
            else{
              locationjoined = loginLocation
            }
    
            locationURL = 'https://maps.googleapis.com/maps/api/staticmap?center=' + locationjoined + '&zoom=18&size=480x410&markers=color:red%7C' + locationjoined + '&key=AIzaSyC0lSt2Arj-MHo6ATzhaxApNVQL1S0BQUY';
          }
    
          message += `<br>
          <img style="width: 90%" class="mb-2" src="${locationURL}" alt="login location">
          `    
        }
        else{
            message += `<div class="row">
                <div class="col-12 text-center my-2">
                    <span><i style="color: ${this.sharedDataService.school_color}" class="fa fa-map-marker"></i> ${tokenInfo.Last_Login_Xlocation}&nbsp;
                    <a href="https://www.google.com/maps?q=${tokenInfo.Last_Login_Xlocation}" target="_blank"><i style="color: ${this.sharedDataService.school_color}; cursor:pointer;" class="fa fa-map"></i></a>
                    </span>
                </div>
            </div>`;
        }

        this.sharedDataService.showAlert("Last Login Information", message, ()=>{}, ()=>{}, 'Okay',undefined);
      }
    
    userHasThisPermission(permissionString){
        let hasPermission = false;
        let uipermissions = this.sharedDataService.roles ? JSON.parse(this.sharedDataService.roles) : [];
        
        hasPermission = uipermissions.find(permission => permission.Client_Application_Resource_Name == permissionString && permission.Permission_Value == 1); 

        return hasPermission ? hasPermission : false;
    }



    tillRolesCome(){
        if (this.sharedDataService.roles !== undefined && this.sharedDataService.role_name !== 'Parent') {
            this.getPermissions(JSON.parse(this.sharedDataService.roles));
        }
        else{
            setTimeout(() => {
                this.tryAgain();
            }, 3000);
        }
    }

    tryAgain(){
        if (this.sharedDataService.roles !== undefined && this.sharedDataService.role_name !== 'Parent') {
            this.getPermissions(JSON.parse(this.sharedDataService.roles));
        }
        else{
            setTimeout(() => {
                this.tillRolesCome();
            }, 3000);
        }
    }

    okayClicked = false;
    showLocationEnforcement = false;
    refuseLocation(){
        this.logMeOut();
        this.showLocationEnforcement = false;      
    }

    async confirmLocation(){
        this.okayClicked = true;
        await this.sharedDataService.geoFindMe();
        setTimeout(() => {
          this.okayClicked = false;
          if (this.sharedDataService.locationSub == 'Unspecified Location') {
            this.sharedDataService.celebrate('Please Permit Location Access for this Site on your Browser');
          }
          else{
            this.showLocationEnforcement = false;
          }
        }, 5000);
    }

    async ngOnInit() {
        await this.sharedDataService.geoFindMe();
        if (this.sharedDataService.locationSub == 'Unspecified Location') {
            
            if (this.sharedDataService.userLocation) {
                this.sharedDataService.locationSub = this.sharedDataService.userLocation;                
            }
        }

        setTimeout(() => {
            if (this.sharedDataService.locationSub.includes('Unspecified') || this.sharedDataService.locationSub == '') {
              this.okayClicked = false;
              this.showLocationEnforcement = true;
            }
        }, 6000);

        this.checkLogin();
        this.innerWidth = window.innerWidth;
        this.pageTitleService.title.subscribe((val: string) => {
            this.header = val;
        });

        this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
            this.url = event.url;
        });

        if (this.url != '/session/login' && this.url != '/session/register' && this.url != '/session/forgot-password' && this.url != '/session/lockscreen') {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar-container');

            /** Perfect scrollbar for sidebar menu **/
            if (window.matchMedia(`(min-width: 960px)`).matches) {
                const ps = new PerfectScrollbar(elemSidebar, {
                    wheelSpeed: 2,
                    wheelPropagation: true,
                    minScrollbarLength: 20
                });
                ps.update();
            }

            /** Perfect scrollbar for chat window **/
            const elemChatbar = <HTMLElement>document.querySelector('.chat-inner ');
            if (window.matchMedia(`(min-width: 960px)`).matches) {
                const pse = new PerfectScrollbar(elemChatbar);
            }
        }

        if (this.media.isActive('xs') || this.media.isActive('sm')){
            this._mode = 'over';
            this._closeOnClickOutside = true;
            this._showBackdrop = true;
            this._opened = false;
            this.sidebarClosed = false;

        }

        this._mediaSubscription = this.media.asObservable().subscribe((change: MediaChange) => {
            let isMobile = (change.mqAlias == 'xs') || (change.mqAlias == 'sm');

            this.isMobile = isMobile;
            this._mode = (isMobile) ? 'over' : 'push';
            this._closeOnClickOutside = (isMobile) ? true : false;
            this._showBackdrop = (isMobile) ? true : false;
            this._opened = !isMobile;
            this.sidebarClosed = false;
        });

        this._routerEventsSubscription = this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd && this.isMobile) {
            this.sidenav.close();
          }
        });

        // // Add slideDown animation to dropdown
        // $('.dropdown').on('show.bs.dropdown', function(e){
        //   $(this).find('.dropdown-menu').first().stop(true, true).slideDown(500);
        // });
        //
        // // Add slideUp animation to dropdown
        // $('.dropdown').on('hide.bs.dropdown', function(e){
        //   $(this).find('.dropdown-menu').first().stop(true, true).slideUp(500);
        // });
        //
        // //Add class on focus of search box in header
        // $('.search-form input').focus(function () {
        //     $(this).parent().addClass('search-active');
        // }).blur(function () {
        //     $(this).parent().removeClass('search-active');
        // });
    }

    MENUITEMS = [
        {
          state: 'home',
          name: ' Home ',
          type: 'link',
          icon: 'fa fa-home'
        }   
        // {
        //   state: 'course-management',
        //   name: 'Course Management',
        //   type: 'link',
        //   icon: 'icon-docs icons',
        // },
      
        // {
        //   state: 'non-academic-management',
        //   name: 'Non Academic Management',
        //   type: 'link',
        //   icon: 'icon-action-redo icons',
        // }
    ];

    financial: boolean;
    notification: boolean;
    empmngt: boolean;
    invmngt: boolean;
    nonacamngt: boolean;
    repmngt: boolean;
    stdtmngt: boolean;
    classmngt: boolean;
    guidedMode: boolean;
    school_color = this.sharedDataService.school_color;
    getPermissions(rolesArray){
        rolesArray.forEach(element => {
          if (element.Permission_Value == 1) {
            if (element.Client_Application_Resource_Name == "Administration") {
                this.financial = true;
                  this.MENUITEMS.push({
                      state: 'administration',
                      name: 'Administration', //this.reduceForIframe? 'Admin' : 'Administration',
                      type: 'link',
                      icon: 'fa fa-building',
                  })
            }
            if (element.Client_Application_Resource_Name == "Financial Management") {
              this.financial = true;
                this.MENUITEMS.push({
                    state: 'financial-management',
                    name: 'Financial Management', //this.reduceForIframe? 'Financial' : 'Financial Management',
                    type: 'link',
                    icon: 'fa fa-money',
                })
            }
            if (element.Client_Application_Resource_Name == "Notification") {
              this.notification = true;
              this.MENUITEMS.push({
                state: 'notification',
                name: 'Notification',
                type: 'link',
                icon: 'glyphicon glyphicon-bullhorn'
              })
            }
            if (element.Client_Application_Resource_Name == "Classroom Management") {
                this.classmngt = true;
                this.MENUITEMS.push({
                    state: 'classroom-management',
                    name: 'Classroom Management', //this.reduceForIframe? 'Classroom' :'Classroom Management',
                    type: 'link',
                    icon: 'fa fa-institution',
                  })
            }
            if (element.Client_Application_Resource_Name == "Course Management") {
                this.classmngt = true;
                this.MENUITEMS.push({
                    state: 'course-management',
                    name: 'Course Management', //this.reduceForIframe? 'Course' :'Course Management',
                    type: 'link',
                    icon: 'fa fa-book',
                })
            }
            if (element.Client_Application_Resource_Name == "Report Management") {
                this.repmngt = true;
                this.MENUITEMS.push({
                    state: 'report-management',
                    name: 'Report Management', //this.reduceForIframe? 'Report' :'Report Management',
                    type: 'link',
                    icon: 'fa fa-pencil',
                  })
            }
            if (element.Client_Application_Resource_Name == "Student Management") {
                this.stdtmngt = true;
                this.MENUITEMS.push({
                    state: 'student-management',
                    name: 'Student Management', //this.reduceForIframe? 'Student' : 'Student Management',
                    type: 'link',
                    icon: 'fa fa-graduation-cap',
                  })
            }
            if (element.Client_Application_Resource_Name == "Staff/Teacher Management") {
                this.empmngt = true;
                this.MENUITEMS.push({
                    state: 'staff-teacher-management',
                    name: 'Staff/Teacher Management', //this.reduceForIframe? 'Staff/Teacher' :'Staff/Teacher Management',
                    type: 'link',
                    icon: 'fa fa-users',
                  })
            }
            if (element.Client_Application_Resource_Name == "Inventory Management") {
                this.invmngt = true;
                this.MENUITEMS.push({
                    state: 'inventory-management',
                    name: 'Inventory Management', //this.reduceForIframe? 'Inventory' : 'Inventory Management',
                    type: 'link',
                    icon: 'fa fa-shopping-cart',
                  })
            }
            if (element.Client_Application_Resource_Name == "Child Development Assessment") {
                this.nonacamngt = true;
                this.MENUITEMS.push({
                    state: 'non-academic-management',
                    name: 'Non-Academic Assessment', //this.reduceForIframe? 'Non-Aca..' : 'Non-Academic Assessment',
                    type: 'link',
                    icon: 'fa fa-star',
                  })
            }
            if (element.Client_Application_Resource_Name == "Payroll Management") {
                this.nonacamngt = true;
                this.MENUITEMS.push({
                    state: 'payroll-management',
                    name: 'Payroll Management', //this.reduceForIframe? 'Payroll' : 'Payroll Management',
                    type: 'link',
                    icon: 'fa fa-handshake',
                  })
            }
            if (element.Client_Application_Resource_Name == "Setup and Configuration") {
                this.nonacamngt = true;
                this.MENUITEMS.push({
                    state: 'setup-and-configuration',
                    name: 'Setup & Configuration', //this.reduceForIframe? 'Setup' : 'Setup & Configuration',
                    type: 'link',
                    icon: 'fa fa-cogs',
                  })
            }
            if (element.Client_Application_Resource_Name == "Subscription") {
                this.nonacamngt = true;
                this.MENUITEMS.push({
                    state: 'school-subscriptions/subscriptions',
                    name: 'Subscription',
                    type: 'link',
                    icon: 'fa fa-heart',
                  })
            }
            if (element.Client_Application_Resource_Name == 'My Time Off Requests') {
              this.manageEmployeeTimeoff[0]=true
            }
            if (element.Client_Application_Resource_Name == 'Request Time Off') {
              this.manageEmployeeTimeoff[1]=true
            }
            if (element.Client_Application_Resource_Name == 'Guided Mode') {
                this.guidedMode = true;
            }
            if (element.Client_Application_Resource_Name == 'My Messages') {
                this.getMessages();                
            }
            if (element.Client_Application_Resource_Name == 'My Payslip') {
                this.getPayslips();                
            }
          }
        });

        this.MENUITEMS = _.sortBy(this.MENUITEMS,  'name');
      }
    ngOnDestroy() {
        if (this._router !== undefined) {
            this._router.unsubscribe();
            this._mediaSubscription.unsubscribe();                
        }
    }

    checkLogin(){
      if(this.sharedDataService.isUserAuthenticated() == false && !this.routingFromForm){
        this.router.navigate(['/']);
      }else{
        return true;
      }
    }

	isFullscreen: boolean = false;

    menuMouseOver(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && this.collapseSidebar) {
            this._mode = 'over';
        }
    }

    menuMouseOut(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && this.collapseSidebar) {
            this._mode = 'push';
        }
    }

	// toggleFullscreen() {
    // 	if (screenfull.enabled) {
    // 		screenfull.toggle();
    //   		this.isFullscreen = !this.isFullscreen;
    // 	}
  	// }

    customizerFunction() {
        this.customizerIn = !this.customizerIn;
    }
     chatWindowFunction() {
        this.chatWindowOpen = !this.chatWindowOpen;
    }

    chatSidebarFunction(){
        this.chatSidebar = !this.chatSidebar;
    }

    sidebarClosedFunction(){
        this.sidebarClosed = !this.sidebarClosed;
    }

    sidebarClosedFunction2(){
        this.sidebarClosed = !this.sidebarClosed;
        this.sidenav.close();
    }
    sidebarOpenFunction2(){
        this.sidebarClosed = true;
        this.sidenav.open();
    }

    changeThemeColor(color){
        this.themeSkinColor = color;
    }

    addMenuItem(): void {
        this.menuItems.add({
            state: 'pages',
            name: 'CHANKYA MENU',
            type: 'sub',
            icon: 'icon-plus icons',
            children: [
                {state: 'blank', name: 'SUB MENU1'}
            ]
        });
    }

   onActivate(e, scrollContainer) {
    scrollContainer.scrollTop = 0;
  }

  titleClickNavigation() {
    if(this.header !== 'Home' && this.header !=='Financial-Management'){
        window.history.back();
    }
  }

  viewProfile(){
    if (this.sharedDataService.cacheCompleteValue < 90 ) {
        this.sharedDataService.celebrate('Loading School Info, Please Wait');
        return 0;
    }
    let canViewProfile: boolean;
    let role = JSON.parse(this.sharedDataService.roles);
    role.forEach(element => {
      if (element.Permission_Value == 1) {
        if (element.Client_Application_Resource_Name == "My Profile") {
            canViewProfile = true;
        }
      }       
    });
    if (canViewProfile) {
      this.router.navigate(['/my-profile']);          
    }
    else{
      this.sharedDataService.celebrate('You are not authorized to access this route');
    }   
  }



  // public canViewWeeklySchedule = false;
  // public canViewWeeklySchedule = JSON.parse(this.sharedDataService.userCache) ? JSON.parse(this.sharedDataService.userCache).Teachers.length !== 0 : false
  public canViewWeeklySchedule = this.sharedDataService.role_name == 'Teacher' ? true : false;
//   public canViewWeeklySchedule = this.sharedDataService.tokenInformationServe ? !!this.sharedDataService.tokenInformationServe.Teacher_Identifier: JSON.parse(this.sharedDataService.userCache).Teachers && JSON.parse(this.sharedDataService.userCache).Teachers.length !== 0;
  viewWeeklySchedule(){
    let canViewProfile: boolean;
    let role = JSON.parse(this.sharedDataService.roles);
    role.forEach(element => {
      if (element.Permission_Value == 1) {
        if (element.Client_Application_Resource_Name == "My Profile") {
            canViewProfile = true;
        }
      }       
    });
    if (canViewProfile) {
      this.router.navigate(['/weekly-schedule']);          
    }
    else{
      this.sharedDataService.celebrate('You are not authorized to access this route');
    }   
  }
  manageEmployeeTimeoff=[false,false]
  viewemployeeTimeof(value,ind){
    if (this.manageEmployeeTimeoff[ind]) {
      this.router.navigate(['/employee-time-off'],{queryParams:{
        type:value
      }});          
    }
    else{
      this.sharedDataService.celebrate('You are not authorized to access this route');
    }   
  }
 
  gottoPaywallUI(){
      this.router.navigate(['/my-subscriptions/subscriptions']);      
  }


  viewPerformance(){
      if (this.sharedDataService.cacheCompleteValue < 90 ) {
          this.sharedDataService.celebrate('Loading School Info, Please Wait');
          return 0;
      }
      let canViewPerformance: boolean;
      let role = JSON.parse(this.sharedDataService.roles);
      role.forEach(element => {
        if (element.Permission_Value == 1) {
          if (element.Client_Application_Resource_Name == "My Login Audit") {
            canViewPerformance = true;
          }
        }       
      });
      if (canViewPerformance) {
        this.router.navigate(['/employee-performance'], { queryParams: { uid: this.sharedDataService.user_id}});          
      }
      else{
        this.sharedDataService.celebrate('You are not authorized to access this route');
      }
  }

  viewPayslips(){
    //   if (this.sharedDataService.cacheCompleteValue < 90 ) {
    //       this.sharedDataService.celebrate('Loading School Info, Please Wait');
    //       return 0;
    //   }
      let canViewPayslip=false;
      let role = JSON.parse(this.sharedDataService.roles);
      role.forEach(element => {
        if (element.Permission_Value == 1) {
          if (element.Client_Application_Resource_Name == "My Payslip") {
            canViewPayslip = true;
          }
        }       
      });
      if (canViewPayslip) {
        if (this.showPayslipBubble) {
            this.router.navigate(['/my-payslips'], { queryParams: { thisMonth : 1}});
        } else {
            this.router.navigate(['/my-payslips']);                
        }
      }
      else{
        this.sharedDataService.celebrate('You are not authorized to access this route');
      }
  }

  viewMessages(){
    // if (this.sharedDataService.cacheCompleteValue < 90 ) {
    //     this.sharedDataService.celebrate('Loading School Info, Please Wait');
    //     return 0;
    // }
    let canViewMessages: boolean;
    let role = JSON.parse(this.sharedDataService.roles);
    role.forEach(element => {
      if (element.Permission_Value == 1) {
        if (element.Client_Application_Resource_Name == "My Messages") {
            canViewMessages = true;
        }
      }       
    });
    if (canViewMessages) {
        if (this.showMessageBubble) {
         let strt = localStorage.getItem('visitedInboxLast') !== null ? localStorage.getItem('visitedInboxLast') : 1;
            this.router.navigate(['/message-inbox'], { queryParams: { today : strt}});
        } else {
            this.router.navigate(['/message-inbox']);                
        }
    }
    else{
      this.sharedDataService.celebrate('You are not authorized to access this route');
    }
}

  logMeOut(){
    // sessionStorage.clear();
    this.router.navigate(['/login']);
   }

   toHome(){
    this.router.navigate(['/home']);
   }

   reloadCache(){
    this.router.navigate(["/home"], {queryParams: {recache: true}});
   }

   public match = [];
   public hasSearchResults: boolean;
   public googleDB = [];
   pName = '';

    find(event){
        this.match = [];
        this.hasSearchResults = true;
        _.forEach(this.sharedDataService.UIs, (ui) => {
            var UIname = ui.Title.toLowerCase();
            if(UIname.includes(this.pName.toLowerCase()))
            this.match.push(ui);
        })
        this.hasSearchResults = this.match.length == 0 || this.pName == "" ? false : true;
    }
    
    redirect(feature){
        if (feature.token == true) {
          this.router.navigate([feature.route]);
          if(feature.route == '/child-assessment-report' && feature.Title == 'Student Boarding House Report'){
            this.router.navigate([feature.route], { queryParams: { boarding: 1}});
          }
          this.sidebarOpenFunction2();        
          this.pName = "";
        } else {
          this.sharedDataService.celebrate("You do not have the permission to access this Feature","Okay");
        }
        this.hasSearchResults = false;
        this.searchOn = false;
    }

    openSearch(){
        if (this.sharedDataService.UIs.length == 0 || this.sharedDataService.windowSize < 500) {
          this.router.navigate(["/home"]);
        }else{
            this.searchOn = true;
            requestAnimationFrame(()=>{
                document.getElementById('isseachsmall').focus()
            })
        }
    }

    openPrivacyPolicy(){
        // open("http://localhost:4201/#/privacy-policy", "_blank");
        open("https://infoviewsims.com/#/privacy-policy", "_blank");
    }

  showErrorLoadingToast() {
    this.matSnackbar.open('Sorry!. An error occured loading your profile. Please reload this page ...', null, {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'right'
    });
  }

  securityFunc(){
    open('https://secure.trust-provider.com/ttb_searcher/trustlogo?v_querytype=W&v_shortname=POSDV&v_search=https://infoviewsims.com/&x=6&y=5', "_blank");
    // var tlJsHost = ((window.location.protocol == "https:") ? "https://secure.trust-provider.com/" : "http://www.trustlogo.com/");
    // document.write(unescape("%3Cscript src='" + tlJsHost + "trustlogo/javascript/trustlogo.js' type='text/javascript'%3E%3C/script%3E"));

    // this.http.get( tlJsHost + 'trustlogo/javascript/trustlogo.js').subscribe(
    // res =>{
    //     
    // },
    // err =>{
    //     
    // })
    // TrustLogo("https://www.positivessl.com/images/seals/positivessl_trust_seal_lg_222x54.png", "POSDV", "none");
  }

  hardReloadSIMS(){
    // location.reload(true);
    this.handleHardReload2(window.location.href);
  }

  hardReloadSIMS2(){
    // url.searchParams.set('reloadTime', Date.now().toString());
    // window.location.href = url.toString();

    this.handleHardReload(window.location.href);
  }

    async handleHardReload(url) {
        await fetch(url, {
            headers: {
                Pragma: 'no-cache',
                Expires: '-1',
                'Cache-Control': 'no-cache',
            }
        });
        window.location.href = url;
        window.location.reload();
    }

    urlWithRndQueryParam(url, paramName?) {
        const ulrArr = url.split('#');
        const urlQry = ulrArr[0].split('?');
        const usp = new URLSearchParams(urlQry[1] || '');
        usp.set(paramName || '_z', `${Date.now()}`);
        urlQry[1] = usp.toString();
        ulrArr[0] = urlQry.join('?');
        return ulrArr.join('#');
    }
    
    handleHardReload2(url) {
        window.location.href = this.urlWithRndQueryParam(url);
        // This is to ensure reload with url's having '#'
        window.location.reload();
    }
    
  schoolColorScrollBar = '#c5c5c54d';
  getProfileInformation() {
    this.schoolName = this.sharedDataService.school_name;
    this.username = this.sharedDataService.user_full_name;
    
    if (this.sharedDataService.schoolCache !== null) {
        const school = JSON.parse(this.sharedDataService.schoolCache);
        school[0].School_Primary_Color = school[0].School_Primary_Color !== null && school[0].School_Primary_Color !== "null" ? school[0].School_Primary_Color : '#6fa6e6';
        school[0].School_Secondary_Color = school[0].School_Secondary_Color !== null && school[0].School_Secondary_Color !== "null"  ? school[0].School_Secondary_Color : '#6fa6e64d';
        if (school[0].School_Logo_S3_URL == null) {
            if(school[0].School_Logo !== null && school[0].School_Logo !== 'null' && school[0].School_Logo !== ''){
                this.logo = this.domSanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + school[0].School_Logo);
                this.sharedDataService.logo = school[0].School_Logo;
            }
        }
        else{
            if(school[0].School_Logo_S3_URL !== 'null' && school[0].School_Logo_S3_URL !== ''){
                this.logo = school[0].School_Logo_S3_URL;
                this.sharedDataService.logo = school[0].School_Logo_S3_URL;
            }
        }
        this.sharedDataService.phone = school[0].Main_Phone_Number;
        this.sharedDataService.website = school[0].Website;
        var col = sessionStorage.getItem('school_color');
        var col2 = sessionStorage.getItem('school_color2');
        if (col == undefined) {
            if (school[0].School_Primary_Color !== null && school[0].School_Primary_Color !== "null" && school[0].School_Primary_Color !== " ") {
                this.schoolColor = school[0].School_Primary_Color;
                this.schoolColor2 = school[0].School_Primary_Color + '4d';
                this.sharedDataService.school_color = school[0].School_Primary_Color;
                this.sharedDataService.school_color2 = school[0].School_Secondary_Color + '4d';
                sessionStorage.setItem('school_color', school[0].School_Primary_Color);
                sessionStorage.setItem('school_color2', school[0].School_Primary_Color + '4d');
            }
            else{
                this.schoolColor = '#6fa6e6';
                this.schoolColor2 = '#6fa6e64d';
                this.sharedDataService.school_color = '#6fa6e6';
                this.sharedDataService.school_color2 = '#6fa6e64d';
                sessionStorage.setItem('school_color', '#6fa6e6');
                sessionStorage.setItem('school_color2', '#6fa6e64d');
            }
        }
        else{
            if (col !== null && col !== 'null' && col !== ' ') {
                this.schoolColor = col == null || col == ' ' ? '#6fa6e6' : col;
                this.schoolColor2 = col2 == null || col2 == ' ' ? '#6fa6e64d' : col2;
                this.sharedDataService.school_color = col == null ? '#6fa6e6' : col;
                this.sharedDataService.school_color2 = col2 == null ? '#6fa6e64d' : col2;
                if (this.schoolColor == null || this.schoolColor == "null" || this.schoolColor == " ") {
                    this.schoolColor = '#6fa6e6';
                    this.schoolColor2 = '#6fa6e64d';
                    this.sharedDataService.school_color = '#6fa6e6';
                    this.sharedDataService.school_color2 = '#6fa6e64d';
                    sessionStorage.setItem('school_color', '#6fa6e6');
                    sessionStorage.setItem('school_color2', '#6fa6e64d');
                }
                else{
                    sessionStorage.setItem('school_color', school[0].School_Primary_Color);
                    sessionStorage.setItem('school_color2', school[0].School_Primary_Color + '4d');
                }
            }
            else{
                this.schoolColor = '#6fa6e6';
                this.schoolColor2 = '#6fa6e64d';
                this.sharedDataService.school_color = '#6fa6e6';
                this.sharedDataService.school_color2 = '#6fa6e64d';
                sessionStorage.setItem('school_color', '#6fa6e6');
                sessionStorage.setItem('school_color2', '#6fa6e64d');
            }   
        }   
        document.body.style.setProperty('--schcol2', this.schoolColor2);
        this.schoolColorScrollBar = this.schoolColor + '99';
        document.body.style.setProperty('--schcol3', this.schoolColorScrollBar);
        localStorage.setItem('lastSchoolColor', this.schoolColor);
        school[0].School_Secondary_Color !== '#6fa6e64d' ? localStorage.setItem('lastSchoolSecColor', school[0].School_Secondary_Color) : localStorage.setItem('lastSchoolSecColor', '#ffffff');
    }
    else{
        const url = '/school?school_id=' + this.sharedDataService.school_id + this.sharedDataService.getActivityForUrl('Home', 'Fetch School Information', 'Homepage', 'Home');
        this.sharedDataService.getHttp(url).subscribe(
            res => {
                const school = res.json();
                this.sharedDataService.schoolCache = JSON.stringify(school);
                let schoolTokenInfo = sessionStorage.getItem('tokenInfo');
                let schoolTokenInfoFull = sessionStorage.getItem('tokenInfoFull');
                let tokenInfo = JSON.parse(schoolTokenInfo);
                let tokenInfoFull = JSON.parse(schoolTokenInfoFull);
                tokenInfo.School_Identifier = tokenInfo.School_Identifier ? tokenInfo.School_Identifier : school;
                tokenInfoFull.School_Identifier = tokenInfoFull.School_Identifier ? tokenInfoFull.School_Identifier : school;
                sessionStorage.setItem('tokenInfo', JSON.stringify(tokenInfo));
                sessionStorage.setItem('tokenInfoFull', JSON.stringify(tokenInfoFull));

                school[0].School_Primary_Color = school[0].School_Primary_Color !== null && school[0].School_Primary_Color !== "null" ? school[0].School_Primary_Color : '#6fa6e6';
                school[0].School_Secondary_Color = school[0].School_Secondary_Color !== null && school[0].School_Secondary_Color !== "null" ? school[0].School_Secondary_Color : '#6fa6e64d';
                if (school[0].School_Logo_S3_URL == null) {
                    if(school[0].School_Logo !== null && school[0].School_Logo !== 'null' && school[0].School_Logo !== ''){
                        this.logo = this.domSanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + school[0].School_Logo);
                        this.sharedDataService.logo = school[0].School_Logo;
                    }
                }
                else{
                    if(school[0].School_Logo_S3_URL !== 'null' && school[0].School_Logo_S3_URL !== ''){
                        this.logo = school[0].School_Logo_S3_URL;
                        this.sharedDataService.logo = school[0].School_Logo_S3_URL;
                    }
                }
                this.sharedDataService.phone = school[0].Main_Phone_Number;
                this.sharedDataService.website = school[0].Website;
                var col = sessionStorage.getItem('school_color');
                var col2 = sessionStorage.getItem('school_color2');
                if (col == undefined) {
                    if (school[0].School_Primary_Color !== null && school[0].School_Primary_Color !== "null" && school[0].School_Primary_Color !== " ") {
                        this.schoolColor = school[0].School_Primary_Color;
                        this.schoolColor2 = school[0].School_Primary_Color + '4d';
                        this.sharedDataService.school_color = school[0].School_Primary_Color;
                        this.sharedDataService.school_color2 = school[0].School_Secondary_Color + '4d';
                        sessionStorage.setItem('school_color', school[0].School_Primary_Color);
                        sessionStorage.setItem('school_color2', school[0].School_Primary_Color + '4d');
                    }
                    else{
                        this.schoolColor = '#6fa6e6';
                        this.schoolColor2 = '#6fa6e64d';
                        this.sharedDataService.school_color = '#6fa6e6';
                        this.sharedDataService.school_color2 = '#6fa6e64d';
                        sessionStorage.setItem('school_color', '#6fa6e6');
                        sessionStorage.setItem('school_color2', '#6fa6e64d');
                    }
                }
                else{
                    if (col !== null && col !== 'null' && col !== ' ') {
                        this.schoolColor = col == null || col == ' ' ? '#6fa6e6' : col;
                        this.schoolColor2 = col2 == null || col2 == ' ' ? '#6fa6e64d' : col2;
                        this.sharedDataService.school_color = col == null ? '#6fa6e6' : col;
                        this.sharedDataService.school_color2 = col2 == null ? '#6fa6e64d' : col2;
                        if (this.schoolColor == null || this.schoolColor == "null" || this.schoolColor == " ") {
                            this.schoolColor = '#6fa6e6';
                            this.schoolColor2 = '#6fa6e64d';
                            this.sharedDataService.school_color = '#6fa6e6';
                            this.sharedDataService.school_color2 = '#6fa6e64d';
                            sessionStorage.setItem('school_color', '#6fa6e6');
                            sessionStorage.setItem('school_color2', '#6fa6e64d');
                        }
                        else{
                            sessionStorage.setItem('school_color', school[0].School_Primary_Color);
                            sessionStorage.setItem('school_color2', school[0].School_Primary_Color + '4d');
                        }
                    }
                    else{
                        this.schoolColor = '#6fa6e6';
                        this.schoolColor2 = '#6fa6e64d';
                        this.sharedDataService.school_color = '#6fa6e6';
                        this.sharedDataService.school_color2 = '#6fa6e64d';
                        sessionStorage.setItem('school_color', '#6fa6e6');
                        sessionStorage.setItem('school_color2', '#6fa6e64d');
                    }   
                }   
                document.body.style.setProperty('--schcol2', this.schoolColor2);
                this.schoolColorScrollBar = this.schoolColor + '99';
                document.body.style.setProperty('--schcol3', this.schoolColorScrollBar);
                localStorage.setItem('lastSchoolColor', this.schoolColor);
                school[0].School_Secondary_Color !== '#6fa6e64d' ? localStorage.setItem('lastSchoolSecColor', school[0].School_Secondary_Color) : localStorage.setItem('lastSchoolSecColor', '#ffffff');
            },
            err => {
                
                let tkn = sessionStorage.getItem('tokenInfo');
                let info = JSON.parse(tkn);
                
                const school = info.School_Identifier;
                
                school[0].School_Logo = null;
                this.sharedDataService.schoolCache = JSON.stringify(school);
                let schoolTokenInfo = sessionStorage.getItem('tokenInfo');
                let schoolTokenInfoFull = sessionStorage.getItem('tokenInfoFull');
                let tokenInfo = JSON.parse(schoolTokenInfo);
                let tokenInfoFull = JSON.parse(schoolTokenInfoFull);
                tokenInfo.School_Identifier = tokenInfo.School_Identifier ? tokenInfo.School_Identifier : school;
                tokenInfoFull.School_Identifier = tokenInfoFull.School_Identifier ? tokenInfoFull.School_Identifier : school;
                sessionStorage.setItem('tokenInfo', JSON.stringify(tokenInfo));
                sessionStorage.setItem('tokenInfoFull', JSON.stringify(tokenInfoFull));
                
                school[0].School_Primary_Color = school[0].School_Primary_Color !== null && school[0].School_Primary_Color !== "null" ? school[0].School_Primary_Color : '#6fa6e6';
                school[0].School_Secondary_Color = school[0].School_Secondary_Color !== null && school[0].School_Secondary_Color !== "null" ? school[0].School_Secondary_Color : '#6fa6e64d';
                if (school[0].School_Logo_S3_URL == null) {
                    if(school[0].School_Logo !== null && school[0].School_Logo !== 'null' && school[0].School_Logo !== ''){
                        this.logo = this.domSanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + school[0].School_Logo);
                        this.sharedDataService.logo = school[0].School_Logo;
                    }
                }
                else{
                    if(school[0].School_Logo_S3_URL !== 'null' && school[0].School_Logo_S3_URL !== ''){
                        this.logo = school[0].School_Logo_S3_URL;
                        this.sharedDataService.logo = school[0].School_Logo_S3_URL;
                    }
                }
                this.sharedDataService.phone = school[0].Main_Phone_Number;
                this.sharedDataService.website = school[0].Website;
                var col = sessionStorage.getItem('school_color');
                var col2 = sessionStorage.getItem('school_color2');
                if (col == undefined) {
                    if (school[0].School_Primary_Color !== null && school[0].School_Primary_Color !== "null" && school[0].School_Primary_Color !== " ") {
                        this.schoolColor = school[0].School_Primary_Color;
                        this.schoolColor2 = school[0].School_Primary_Color + '4d';
                        this.sharedDataService.school_color = school[0].School_Primary_Color;
                        this.sharedDataService.school_color2 = school[0].School_Secondary_Color + '4d';
                        sessionStorage.setItem('school_color', school[0].School_Primary_Color);
                        sessionStorage.setItem('school_color2', school[0].School_Primary_Color + '4d');
                    }
                    else{
                        this.schoolColor = '#6fa6e6';
                        this.schoolColor2 = '#6fa6e64d';
                        this.sharedDataService.school_color = '#6fa6e6';
                        this.sharedDataService.school_color2 = '#6fa6e64d';
                        sessionStorage.setItem('school_color', '#6fa6e6');
                        sessionStorage.setItem('school_color2', '#6fa6e64d');
                    }
                }
                else{
                    if (col !== null && col !== 'null' && col !== ' ') {
                        this.schoolColor = col == null || col == ' ' ? '#6fa6e6' : col;
                        this.schoolColor2 = col2 == null || col2 == ' ' ? '#6fa6e64d' : col2;
                        this.sharedDataService.school_color = col == null ? '#6fa6e6' : col;
                        this.sharedDataService.school_color2 = col2 == null ? '#6fa6e64d' : col2;
                        if (this.schoolColor == null || this.schoolColor == "null" || this.schoolColor == " ") {
                            this.schoolColor = '#6fa6e6';
                            this.schoolColor2 = '#6fa6e64d';
                            this.sharedDataService.school_color = '#6fa6e6';
                            this.sharedDataService.school_color2 = '#6fa6e64d';
                            sessionStorage.setItem('school_color', '#6fa6e6');
                            sessionStorage.setItem('school_color2', '#6fa6e64d');
                        }
                        else{
                            sessionStorage.setItem('school_color', school[0].School_Primary_Color);
                            sessionStorage.setItem('school_color2', school[0].School_Primary_Color + '4d');
                        }
                    }
                    else{
                        this.schoolColor = '#6fa6e6';
                        this.schoolColor2 = '#6fa6e64d';
                        this.sharedDataService.school_color = '#6fa6e6';
                        this.sharedDataService.school_color2 = '#6fa6e64d';
                        sessionStorage.setItem('school_color', '#6fa6e6');
                        sessionStorage.setItem('school_color2', '#6fa6e64d');
                    }   
                }   
                document.body.style.setProperty('--schcol2', this.schoolColor2);
                this.schoolColorScrollBar = this.schoolColor + '99';
                document.body.style.setProperty('--schcol3', this.schoolColorScrollBar);
                localStorage.setItem('lastSchoolColor', this.schoolColor);
                school[0].School_Secondary_Color !== '#6fa6e64d' ? localStorage.setItem('lastSchoolSecColor', school[0].School_Secondary_Color) : localStorage.setItem('lastSchoolSecColor', '#ffffff');
            }
        );
    }
  }

  getUserProfilePicture() {
    if (this.sharedDataService.userCache !== null) {
        
        let img = this.sharedDataService.profileImage !== 'assets/3.png' ? this.sharedDataService.profileImage : this.sharedDataService.profileImage;
        this.profileImage = img;  
    }
    else{
        
        const url = '/school/employees?school_id=' + this.sharedDataService.school_id + '&school_employee_id=' + this.sharedDataService.emp_Id + '&status=Active' + this.sharedDataService.getActivityForUrl('Home', 'Fetch Employee Information', 'Homepage', 'Home');
        this.sharedDataService.getHttp(url).subscribe(
            res => {
                const employees = res.json();
                this.sharedDataService.userCache = JSON.stringify(employees);
                if (!_.isEmpty(employees.Staff)) {
                  this.profileImage = employees.Staff[0].Employee_Image_S3_URL == null ? 'assets/3.png' : employees.Staff[0].Employee_Image_S3_URL;
                  this.sharedDataService.profileImage = this.profileImage;
                  // sessionStorage.setItem('role_id', employees.Staff[0].Role_Identifier);
                }
                else {
                  if (!_.isEmpty(employees.Teachers)) {
                    this.profileImage = employees.Teachers[0].Employee_Image_S3_URL == null ? 'assets/3.png' : employees.Teachers[0].Employee_Image_S3_URL;
                    this.sharedDataService.profileImage = this.profileImage;
                    // sessionStorage.setItem('role_id', employees.Teachers[0].Role_Identifier);
                  }
                  else {
                      this.profileImage = 'assets/3.png';
                      this.sharedDataService.profileImage = this.profileImage;
                  }
                }
            },
            err => {
                
                this.profileImage = 'assets/3.png';
                this.sharedDataService.profileImage = this.profileImage;
            }
        );
    }
  }

  myMessages = [];
  showMessageBubble = false;
  gottenMessagesCache = false;
  getMessages(){
      this.gottenMessagesCache = false;
    if (!this.sharedDataService.myMessages) {
        let strt = localStorage.getItem('visitedInboxLast') !== null ? localStorage.getItem('visitedInboxLast') : this.sharedDataService.getTheDate();
        let getStudentsBySchool = this.sharedDataService.apiUrl +'/school/inbound_message_log?school_id=' + this.sharedDataService.school_id + '&start_date=' + strt + '&end_date=' + this.sharedDataService.getTheDate();
        
        this.http.get(getStudentsBySchool, this.sharedDataService.returnRequestOptions() ).subscribe(
          (res) => {
            let pudo = res.json();
            let tempo = Array.isArray(pudo) ? pudo : [];
            tempo.forEach(element => {
                element.Read = false;
            });
            this.myMessages = _.sortBy(tempo, 'Created_Datetime');
            
            this.sharedDataService.myMessages = JSON.stringify(this.myMessages);
            this.showMessageBubble = this.myMessages.length == 0 ? false : true;
            let lastVisited = localStorage.getItem('visitedInboxLast');
            let today = this.sharedDataService.getTheDate();
            if (today == lastVisited) {
                this.showMessageBubble = false;
            }
            this.gottenMessagesCache = true;
          },
          (err) => { 
          //  this.sharedDataService.celebrate(err._body.toString(), 'Okay'); 
          }
        );            
    }
    else{
        let pudo = JSON.parse(this.sharedDataService.myMessages);
        let tempo = Array.isArray(pudo) ? pudo : [];
        tempo.forEach(element => {
            if (element.Read == false) {
                this.myMessages.push(element);
            }
        });
        
        this.showMessageBubble = this.myMessages.length == 0 ? false : true;
        let lastVisited = localStorage.getItem('visitedInboxLast');
        let today = this.sharedDataService.getTheDate();
        if (today == lastVisited) {
            this.showMessageBubble = false;
        }
        this.gottenMessagesCache = true;
    }
  }

  myPayslips = [];
  showPayslipBubble = false;
  gottenPayslipCache = false;
  getPayslips(){
      this.gottenPayslipCache = false;
      let returnedPayslips = [];
    if (!this.sharedDataService.myPayslips) {
        let monthAgo = moment(this.sharedDataService.getTheDate()).subtract(31, 'days');
        let aMonthAgo = monthAgo.format('YYYY-MM-DD');
        
        const { Employee } = JSON.parse(sessionStorage.getItem('tokenInfo'));
        let getStudentsBySchool = this.sharedDataService.apiUrl +'/employee_payslip_report?school_id=' + this.sharedDataService.school_id + '&school_employee_id=' + this.sharedDataService.emp_Id + '&payroll_begin_date=' + aMonthAgo + '&payroll_end_date=' +  this.sharedDataService.getTheDate();
        let type = '';
        if (this.sharedDataService.emp_Id) {
            if (!Employee[0].Teaching_Staff_Indicator) {
                type = 'Staff'
            }
            else {
                type = 'Teacher'
            }
        }
        getStudentsBySchool += '&emp_type=' + type
        
        this.http.get(getStudentsBySchool, this.sharedDataService.returnRequestOptions() ).subscribe(
          (res) => {
            let pudo = res.json();
            let tempo = Array.isArray(pudo) ? pudo : [];
            returnedPayslips = tempo;
            
            let viewedSlips = localStorage.getItem('viewedPayslips');
            if (viewedSlips) {
                let slips = JSON.parse(viewedSlips);
                let newSlips = [];
                returnedPayslips.forEach(returnedSlip => {
                    let seenSlip = slips.find(savedSlip => parseInt(savedSlip) == returnedSlip.General_Ledger_Identifier);
                    if (!seenSlip) newSlips.push(returnedSlip);
                });

                if (newSlips.length) {
                    this.myPayslips = newSlips;
                    this.sharedDataService.myPayslips = JSON.stringify(newSlips);
                    this.showPayslipBubble = true;
                }
            }
            else if (returnedPayslips.length){
                // let glitems = returnedPayslips.map(slip => slip.General_Ledger_Identifier);
                // localStorage.setItem('viewedPayslips', JSON.stringify(glitems));
                this.myPayslips = returnedPayslips;
                this.showPayslipBubble = true;
            }
            this.gottenPayslipCache = true;
          },
          (err) => {
            // this.sharedDataService.celebrate(err._body.toString(), 'Okay');
         }
        );            
    }
    else{
        let pudo = JSON.parse(this.sharedDataService.myPayslips);
        let tempo = Array.isArray(pudo) ? pudo : [];
        returnedPayslips = tempo;

        let viewedSlips = localStorage.getItem('viewedPayslips');
        if (viewedSlips) {
            let slips = JSON.parse(viewedSlips);
            let newSlips = [];
            returnedPayslips.forEach(returnedSlip => {
                let seenSlip = slips.find(savedSlip => parseInt(savedSlip) == returnedSlip.General_Ledger_Identifier);
                if (!seenSlip) newSlips.push(returnedSlip);
            });

            if (newSlips.length) {
                this.myPayslips = newSlips;
                this.sharedDataService.myPayslips = JSON.stringify(newSlips);
                this.showPayslipBubble = true;
            }
        }
        else if (returnedPayslips.length){
            // let glitems = returnedPayslips.map(slip => slip.General_Ledger_Identifier);
            // localStorage.setItem('viewedPayslips', JSON.stringify(glitems));
            this.myPayslips = returnedPayslips;
            this.showPayslipBubble = true;
        }
        
        this.gottenPayslipCache = true;
    }
  }


  onEmployeeBranchSelected(branch) {
    this.sharedDataService.selectedEmployeeBranch = branch;
  }



}





// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/main/main.component.ts